//
//
//
//
//
//
//
//

export default {
  props: {
    remainingTimeMS: {
      type: Number,
      default: 0
    },
    stopTimer: {
      type: Boolean
    }
  },
  data: function () {
    return {
      remainingTimeLocal: this.remainingTimeMS,
      passedTime: 0,
      timer: null
    }
  },
  computed: {
    timeText: function () {
      const ms = this.remainingTimeLocal % 1000

      const timeInSec = (this.remainingTimeLocal - ms) / 1000
      const seconds = timeInSec % 60

      const timeInMin = (timeInSec - seconds) / 60
      const minutes = timeInMin % 60

      const hours = (timeInMin - minutes) / 60
      return (hours >= 10 ? hours : '0' + hours) + ':' +
        (minutes >= 10 ? minutes : '0' + minutes) + ':' +
        (seconds >= 10 ? seconds : '0' + seconds)
    }
  },
  watch: {
    stopTimer: function (val) {
      if (val) {
        clearInterval(this.timer)
      }
    },
    remainingTimeMS: {
      handler: function (val) {
        if (val) {
          this.remainingTimeLocal = val
        }
      },
      immediate: true
    }
  },
  created: function () {
    document.addEventListener('visibilitychange', this.onVisibilityChange)
    this.timer = setInterval(() => {
      this.updateRemainingTime()
    }, 1000)
  },
  beforeDestroy: function () {
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
    clearInterval(this.timer)
  },
  methods: {
    onVisibilityChange: function () {
      if (document.visibilityState === 'visible') {
        this.$emit('visibility-change')
      }
    },
    updateRemainingTime: function () {
      this.remainingTimeLocal -= 1000
      if (this.remainingTimeLocal <= 0) {
        this.$emit('break-time-out')
      }
    }
  }
}

